import axios from 'axios';

let wakingUpNotified = false;

// Global request interceptor
axios.interceptors.request.use(
    (config) => {
        config.wakingTimer = setTimeout(() => {
            if (!wakingUpNotified) {
                wakingUpNotified = true;
                window.dispatchEvent(new CustomEvent('api-slow'));
            }
        }, 5000);
        return config;
    },
    (error) => Promise.reject(error)
);

// Global response interceptor
axios.interceptors.response.use(
    (response) => {
        if (response.config.wakingTimer) {
            clearTimeout(response.config.wakingTimer);
        }
        wakingUpNotified = false;
        window.dispatchEvent(new CustomEvent('api-ready'));
        return response;
    },
    (error) => {
        if (error.config?.wakingTimer) {
            clearTimeout(error.config.wakingTimer);
        }
        wakingUpNotified = false;
        window.dispatchEvent(new CustomEvent('api-ready'));
        return Promise.reject(error);
    }
);

export default axios;